import { render, staticRenderFns } from "./areauser.vue?vue&type=template&id=193e4d97&scoped=true&"
import script from "./areauser.vue?vue&type=script&lang=js&"
export * from "./areauser.vue?vue&type=script&lang=js&"
import style0 from "./areauser.vue?vue&type=style&index=0&id=193e4d97&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193e4d97",
  null
  
)

export default component.exports